import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { ICRUDRepo } from "../../../core/models";
import { clientFromJson, clientToJson, IClient, IClientForm } from "./entities";

interface IClientRepo extends ICRUDRepo<IClient, IClientForm> {}

const URL = "v1/client";

const ClientRepoImplFactory = (apiClient: ApiClient): IClientRepo => {
  const r: IClientRepo = {
    ...generateCrudRepoFactory<IClient, IClientForm>(apiClient, URL, clientFromJson, clientToJson),
  };

  return r;
};

export const ClientRepoImpl = ClientRepoImplFactory(apiClient);
